var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRaffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5026 14.1121L22.3014 20.922L16.391 16.0394L10.4805 20.922L12.2793 14.2406L6.88281 9.74348L13.8212 9.35801L16.391 2.93359L18.9607 9.35801L25.8991 9.74348L20.5026 14.1121ZM18.9607 24.7766H17.6758V20.922L16.391 19.6371L15.1061 20.922V24.7766H13.8212C12.4078 24.7766 11.2514 25.933 11.2514 27.3464V28.6313H21.5305V27.3464C21.5305 26.6648 21.2597 26.0112 20.7778 25.5293C20.2959 25.0474 19.6423 24.7766 18.9607 24.7766Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1223 13.6327L19.8122 13.8838L19.9141 14.2696L21.223 19.2247L16.7916 15.5639L16.3988 15.2394L16.006 15.5639L11.5867 19.2147L12.8827 14.4009L12.9853 14.0196L12.682 13.7668L8.48871 10.2724L13.8632 9.97381L14.2557 9.952L14.4016 9.58707L16.3988 4.59423L18.3959 9.58707L18.5419 9.952L18.9343 9.97381L24.2756 10.2705L20.1223 13.6327Z",
    fill: "#DCA11C",
    stroke: "black",
    strokeWidth: 1.23349
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaffle);
export default __webpack_public_path__ + "static/media/raffle.a530ce15f68c743588a7bde1331d86df.svg";
export { ForwardRef as ReactComponent };